import type { BrowserClient } from '@amplitude/analytics-types';

function trackEvent(eventName: string, properties: Record<string, unknown> = {}, isProd = false) {
  const { amplitude, groupsAmplitude } = window;

  if (!amplitude) return;

  const trackAndFlush = (instance: BrowserClient) => {
    instance.setTransport('beacon');
    const result = instance.track(eventName, properties);
    instance.flush();
    return result;
  };

  const logDebug = (label: string, result: { promise?: Promise<unknown> }) => {
    result.promise
      ?.then((response) => {
        console.log(`${label} track response:`, response);
      })
      .catch((error) => {
        console.error(`${label} track error:`, error);
      });
  };

  const heResult = trackAndFlush(amplitude);
  const groupsResult = groupsAmplitude ? trackAndFlush(groupsAmplitude) : null;

  if (!isProd) {
    console.log('Tracking event:', eventName, properties);
    logDebug('Amplitude', heResult);
    if (groupsResult) logDebug('GroupsAmplitude', groupsResult);
  }
}

export default trackEvent;
